module.exports = __webpack_public_path__ + "img/registerBanner.2fde8448.png";